import React from 'react';
import PokemonBinder from "./PokemonBinder";
import './Home.css';

function Home({ collection }) { 
  return (
    <div className="home-page">
      <PokemonBinder collection={collection}/>
    </div>
  );
}

export default Home;
